import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'lib-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css'],
  standalone: false
})
export class AuthCallbackComponent implements OnInit {
  error: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // pull access code from query params. send to server to exchange for access token
    this.authService.isLoggedIn().subscribe(loggedIn => {
      if (loggedIn) {
        this.authService
          .doesAuthRequestTokenMatch(this.route.snapshot.queryParams.code)
          .subscribe(res => {
            if (res) {
              this.router.navigate(['/']);
            } else {
              this.authService.signOut(this.route);
            }
          });
      } else {
        this.authService.completeAuthentication(this.route.snapshot.queryParams.code);
      }
    });
  }
}
